<template>
  <div class="bussiness-scope-page">
    <Banner :bannerUrl="bannerUrl" :title="bannerTitle" :text="bannerText" />
    <div class="container">
      <h2 v-if="pageTitle" class="com-top-tile" :style="{ hasDesc: titleDesc }">{{ pageTitle }}</h2>
      <p v-if="titleDesc" class="title-desc">{{ titleDesc }}</p>
      <div class="characteristics fb">
        <div class="character-ifo fcc" v-for="(item, index) in characterList" :key="index">
          <img :src="item.img" />
          <div class="title">{{ item.title }}</div>
          <p>{{ item.text }}</p>
        </div>
      </div>
      <div class="service-list">
        <div
          v-for="(item, index) in imgTextList"
          class="list-item fb"
          :class="{ rightPosition: isRightPostion }"
          :key="index"
        >
          <img :src="item.img">
          <div class="r_text">
            <div class="title">{{ item.title }}</div>
            <p>{{ item.text }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Banner from '@/components/banner'
import { defineProps } from 'vue';
defineProps({
  pageTitle: {
    type: String,
    default: ''
  },
  titleDesc: {
    type: String,
    default: ''
  },
  bannerUrl: {
    type: String,
    default: ''
  },
  bannerTitle: {
    type: String,
    default: ''
  },
  bannerText: {
    type: String,
    default: ''
  },
  characterList: {
    type: Array,
    default: () => [],
  },
  imgTextList: {
    type: Array,
    default: () => [],
  },
  isRightPostion: {
    type: Boolean,
    default: false
  }
});
</script>

<style lang="less" scoped>
.bussiness-scope-page {
  margin-bottom: 125px;

  /deep/ .com-banner {
    margin-bottom: 80px;
    .banner_title {
      font-size: 32px;
      font-weight: 600;
    }
    .banner_text {
      font-size: 16px;
      line-height: 160%;
      max-width: 592px;
    }
  }
  .com-top-tile {
    padding-left: 0;
    &.hasDesc {
      margin-bottom: 18px;
    }
  }
  .title-desc {
    font-size: 16px;
    line-height: 140%;
    color: #3B4755;
    margin-bottom: 80px;
  }
  .characteristics {
    gap: 126px;
    .character-ifo {
      img {
        width: 100px;
        height: 100px;
      }
      .title {
        margin-top: 23px;
        color: #121D50;
        font-size: 16px;
      }
      p {
        text-align: center;
        font-size: 16px;
        color: #5C6C7B;
        margin-top: 6px;
        line-height: 140%;
      }
    }
  }
  .service-list {
    margin-top: 90px;
    .list-item {
      margin-bottom: 60px;
      gap: 54px;
      &.rightPosition {
        &:nth-child(odd) {
          flex-direction: row-reverse;
        }
        &:nth-child(even) {
          flex-direction: row;
        }
      }
      &:nth-child(even) {
        flex-direction: row-reverse;
      }
      img {
        width: 510px;
        height: 510px;
        border-radius: 10px;
      }
      .r_text {
        flex: 1;
        .title {
          font-size: 30px;
          color: #000000;
          line-height: 200%;
        }
        p {
          color: #454852;
          font-size: 16px;
          line-height: 200%;
          margin-top: 6px;
          word-break: break-all;
        }
      }
    }
  }
}
</style>